import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function NcertBookCheTopics() {
  return (
    <>

      <AllSubjectTopics subject="chemistry" type="ncertbook" />


    </>
  );
} 

export default NcertBookCheTopics;